import { render, staticRenderFns } from "./NewCouncil.vue?vue&type=template&id=84c88fc6&scoped=true&"
import script from "./NewCouncil.vue?vue&type=script&lang=js&"
export * from "./NewCouncil.vue?vue&type=script&lang=js&"
import style0 from "./NewCouncil.vue?vue&type=style&index=0&id=84c88fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c88fc6",
  null
  
)

export default component.exports